import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

type EmptyStateProps = {
  message: string;
  height: number;
  icon?: ReactNode;
};

// Renders in place of a chart/list when its domain has no data yet, so the
// card keeps its real layout and height instead of showing fabricated numbers.
export const EmptyState = ({ message, height, icon }: EmptyStateProps) => (
  <Box
    sx={{
      height,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      color: "text.disabled",
    }}
  >
    {icon}
    <Typography variant="body2" color="text.disabled">
      {message}
    </Typography>
  </Box>
);
